import $ from "/home/wpsoup6/domains/tijdschriftenplaza.nl/public_html/wp-content/plugins/wp-soup-framework/node_modules/jquery";

/**
 * Insert autonative ad tags.
 */
const paragraphs = $(
  ".single:not(.hide-ads) .article-content p:not([class]):not(:empty), .single:not(.hide-ads) .article-content p.lead:not(:empty)"
).slice(1, -1); // Remove first two paragraphs.
const length = paragraphs.length;

if (length > 0) {
  let i = 1; // Skip 1 when placing divs.
  paragraphs.each(function (index) {
    if (index + 1 === length) {
      return;
    }

    if (index % 3 === 0) {
      if (i > 3) {
        return;
      }

      const paragraph = $(this);
      // Skip if heading inside container.
      if (paragraph.parents(".wp-block-ms-container").length) {
        return;
      }

      // Skip if previous element is intro.
      if (paragraph.prev().hasClass("lead")) {
        i++;

        return;
      }

      // Only insert div when previous element is not the title.
      if (!paragraph.prev().is("h1")) {
        // Add first div if this is the first iteration and there's no intro.
        if (i === 1) {
          i++;
          paragraph.after(`<div id="adf-autonative"></div>`);

          return;
        }

        // Add subsequent divs.
        paragraph.after(`<div id="adf-autonative-${i}"></div>`);
        i++;
      }
    }
  });
}
